import React, { useState } from 'react';
import '@fontsource/montserrat';
import '@fontsource/poppins';
import './App.css';

// Importando componentes
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Mentorship from './components/Mentorship';
import Topics from './components/Topics';
import ImplantCourse from './components/ImplantCourse';
import Locations from './components/Locations';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ApplicationForm from './components/ApplicationForm';

function App() {
  const [showApplicationForm, setShowApplicationForm] = useState(false);

  const handleOpenForm = () => {
    setShowApplicationForm(true);
  };

  const handleCloseForm = () => {
    setShowApplicationForm(false);
  };

  return (
    <div className="font-body text-neutral-dark">
      <Header onOpenForm={handleOpenForm} />
      <Hero onOpenForm={handleOpenForm} />
      <About onOpenForm={handleOpenForm} />
      <Mentorship onOpenForm={handleOpenForm} />
      <Topics onOpenForm={handleOpenForm} />
      <ImplantCourse onOpenForm={handleOpenForm} />
      <Locations />
      <Contact />
      <Footer />
      {showApplicationForm && <ApplicationForm onClose={handleCloseForm} />}
    </div>
  );
}

export default App;


